module.exports = __webpack_public_path__ + "static/media/aurora-lose.6128d590.png";